import { EVIDENCE_BASE_POINTS } from '../../constants/ipScoringConfig';
import type { RootState } from '..';

export const selectEvidenceFinds = (state: RootState) =>
  state.scoring.evidenceFinds;

// Derived score for gameplay display: just evidence count × base points (no multipliers)
// Guarantees score never decreases during gameplay
export const selectGameplayDisplayScore = (state: RootState) =>
  state.scoring.evidenceFinds.length * EVIDENCE_BASE_POINTS;
export const selectCurrentIPScore = (state: RootState) =>
  state.scoring.currentIPScore;
export const selectLastClueTimestamp = (state: RootState) =>
  state.scoring.lastClueTimestamp;

export const selectBonusStreak = (state: RootState) =>
  state.scoring.bonusStreak;
export const selectHighestSpeedStreak = (state: RootState) =>
  state.scoring.highestSpeedStreak;

export const selectFirstFindTimestamp = (state: RootState) =>
  state.scoring.firstFindTimestamp;
export const selectLastFindTimestamp = (state: RootState) =>
  state.scoring.lastFindTimestamp;
export const selectTotalCompletionTime = (state: RootState) =>
  state.scoring.totalCompletionTime;
